export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    isLogGridOpen: state => state.logGridIsOpen,

    getDataTableOption: state => state.dataTableOptions,

    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getSearchFields: state => state.searchFields,

    getLogHeaderFields: state => state.logHeaderFields,
    getLogActions: state => state.logActions
}
